import { steamConstants } from '../constants'

const initialState = {
  authenticated: false,
  errorMessage: null,
  steamid: null,
  accessToken: null,
}

const steamReducer = (state = initialState, action) => {
  const { response, error } = action
  switch (action.type) {
    // Auth User
    case steamConstants.SAVE_AUTH_USER:
      return {
        ...state,
        authenticated: true,
        steamid: response.steamid,
        accessToken: response.accessToken,
      }
    // Logout
    case steamConstants.REMOVE_AUTH_USER:
      return { ...state, authenticated: false, steamid: null, accessToken: null }

    case steamConstants.STEAM_ACTIVATE_GAME_SUCCESS:
      return { ...state }
    case steamConstants.STEAM_ACTIVATE_GAME_FAILURE:
      if (error.key_registered === false) {
        return { ...state, authenticated: false, errorMessage: error.register_result }
      }
      return { ...state }

    // ComponentDidMount check for auth
    case steamConstants.STEAM_CHECK_AUTHENTICATE_SUCCESS:
      return { ...state, authenticated: true }
    case steamConstants.STEAM_CHECK_AUTHENTICATE_FAILURE:
      return { ...state, authenticated: false }

    // Redirect login
    case steamConstants.USER_LOGIN_FAILURE:
      return { ...state, authenticated: false }
    case steamConstants.USER_LOGIN_SUCCESS:
      return { ...state, authenticated: true }

    // Steam User's Ticket - localStorage
    case steamConstants.SAVE_USER_TICKET_SUCCESS:
      return { ...state, steamid: response.steamid, accessToken: response.access_token }
    case steamConstants.SAVE_USER_TICKET_FAILURE:
      return { ...state, steamid: null, accessToken: null }
    default:
      return state
  }
}

export default steamReducer
